import type { IntlShape } from 'react-intl'
import type { InvoiceDetailHeader } from '../types'

export const customerHeaders: InvoiceDetailHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laji',
				description: 'Invoice type label',
			}),
		key: 'type',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskun nro.',
				description: 'Invoice number label',
			}),
		key: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Asiakas',
				description: 'Customer name label',
			}),
		key: 'customerName',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lähiosoite',
				description: 'Street address label',
			}),
		key: 'streetAddress',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Postinumero',
				description: 'Postal code label',
			}),
		key: 'postalCode',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Postitoimipaikka',
				description: 'City label',
			}),
		key: 'city',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Puhelin',
				description: 'Phone number label',
			}),
		key: 'phone',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Sähköposti',
				description: 'Email label',
			}),
		key: 'email',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Toimitustapa',
				description: 'Delivery method label',
			}),
		key: 'deliveryMethod',
	},
]

export const metadataHeaders: InvoiceDetailHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Päivämäärä',
				description: 'Invoice date label',
			}),
		key: 'invoiceDate',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Eräpäivä',
				description: 'Due date label',
			}),
		key: 'dueDate',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksu pvm',
				description: 'Payment date label',
			}),
		key: 'paymentDate',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Viitenumero',
				description: 'Reference number label',
			}),
		key: 'referenceNumber',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'RF-viite',
				description: 'RF reference label',
			}),
		key: 'rfReference',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Suoritus',
				description: 'Receipt link label',
			}),
		key: 'receiptLink',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tosite',
				description: 'Document ID label',
			}),
		key: 'documentId',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Myyntitilaus',
				description: 'Sales order label',
			}),
		key: 'salesOrder',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tilaus',
				description: 'Order label',
			}),
		key: 'order',
	},
]

export const amountHeaders: InvoiceDetailHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Veroton hinta',
				description: 'Net price label',
			}),
		key: 'netAmount',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'ALV:n osuus',
				description: 'VAT share label',
			}),
		key: 'vatAmount',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskun summa',
				description: 'Total amount label',
			}),
		key: 'totalAmount',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Avoin summa',
				description: 'Open amount label',
			}),
		key: 'openAmount',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lähetetty',
				description: 'Sent date label',
			}),
		key: 'sentDate',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskutustapa',
				description: 'Billing method label',
			}),
		key: 'billingMethod',
	},
]

export const productHeaders: InvoiceDetailHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Koodi',
				description: 'Product code column',
			}),
		key: 'productCode',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tuotenimike',
				description: 'Product name column',
			}),
		key: 'productName',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lisätietoja',
				description: 'Additional info column',
			}),
		key: 'additionalInfo',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tili',
				description: 'Account column',
			}),
		key: 'account',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kustannuspaikka',
				description: 'Cost center column',
			}),
		key: 'costCenter',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Ale %',
				description: 'Discount percentage column',
			}),
		key: 'discountPercent',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Määrä',
				description: 'Quantity column',
			}),
		key: 'quantity',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'á-hinta',
				description: 'Unit price column',
			}),
		key: 'unitPrice',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Valuutta',
				description: 'Currency column',
			}),
		key: 'currency',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Yhteensä',
				description: 'Total column',
			}),
		key: 'total',
	},
]

export const statusHeaders: InvoiceDetailHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Numero',
				description: 'Invoice number',
			}),
		key: 'invoiceNumber',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Päivämäärä',
				description: 'Date',
			}),
		key: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lisätietoja',
				description: 'Additional information',
			}),
		key: 'additionalInformation',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskun summa',
				description: 'Invoice total amount',
			}),
		key: 'totalAmount',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Loppusaldo',
				description: 'Final balance',
			}),
		key: 'finalBalance',
	},
]
